import { takeLatest, put, select } from 'redux-saga/effects';
import { submitPasswordReset } from './routines';
import { passwordReset } from '@simplywallst/services';
import { getPathFromRoute } from '@ducks/location/selectors';
import { ROUTE_USER_PROFILE } from '@/constants/routes';
import { ahoy } from '@ducks/saga';

interface SagaActions {
  type: string;
  payload: {
    email?: string;
  };
}

function* submitPasswordResetWorker(action: SagaActions) {
  try {
    const {
      payload: { email = '' },
    } = action;
    const redirectPath = yield select(getPathFromRoute(ROUTE_USER_PROFILE));
    const caller = ahoy();
    yield caller(passwordReset, {
      email,
      redirect: redirectPath,
    });
    yield put(submitPasswordReset.success());
  } catch (reason: any) {
    let title = '';
    if (reason.message) {
      title = reason.message;
    } else if (reason.response && reason.response.data) {
      const {
        response: {
          data: { errors },
        },
      } = reason;
      title = errors;
    }
    yield put(submitPasswordReset.failure({ errorMessage: title }));
  } finally {
    yield put(submitPasswordReset.fulfill());
  }
}

/** @todo: deprecate unused */
function* submitPasswordResetWatcher() {
  yield takeLatest(submitPasswordReset.TRIGGER, submitPasswordResetWorker);
}

export const exportableSagas = [submitPasswordResetWatcher];
